import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { URLParse } from 'lib/storeLocale/client'
import { getGeoLocation } from 'selectors/user/cookie'

type Props = React.HTMLProps<HTMLAnchorElement>

const SALink: FC<Props> = (props) => {
  const geoLocation = useSelector(getGeoLocation)

  const { children, href: url } = props
  const { storeLocale } = geoLocation
  // TODO - GEO PRICE - remove ternary -> const link =  URLParse(url, storeLocale)
  let link = url

  // Some Components use an <a /> tab but don't have a link, skip this LOGIC
  if (url) {
    const data = URLParse(url, storeLocale)
    const { href } = data
    link = href
  }

  // Copy/Clone All Props
  const anchorProps: Partial<Props> = { ...props }
  // Delete Attributes we DO NOT NEED
  delete anchorProps.children
  // Update HREF - Leave Log if we need to check Server Side
  // console.log({ link, hasFeatureFlagsGeoPricesForAustralia })
  anchorProps.href = link
  return (
    <a tabIndex={0} {...{ ...anchorProps }}>
      {children}
    </a>
  )
}

export default SALink
